import React, { useContext, useState } from 'react';
import tw from 'twin.macro';
import Carousel from 'react-multi-carousel';
import { Icon } from '../icon';
import { ArrowIcon } from 'icons';
import { AppContext } from '../context';

const responsive = (maxNum) => {
  return {
    superLargeDesktop: {
      breakpoint: { min: 3000, max: 4000 },
      items: 5,
    },
    desktop: {
      breakpoint: { min: 1024, max: 3000 },
      items: maxNum,
      slidesToSlide: maxNum,
      partialVisibilityGutter: 30,
    },
    tablet: {
      breakpoint: { min: 768, max: 1024 },
      items: 1,
      slidesToSlide: 1,
      partialVisibilityGutter: 0,
    },
    mobile_large: {
      breakpoint: { min: 540, max: 768 },
      items: 1,
      slidesToSlide: 1,
      partialVisibilityGutter: 0,
    },
    mobile: {
      breakpoint: { min: 0, max: 540 },
      items: 1,
      slidesToSlide: 1,
      partialVisibilityGutter: 0,
    },
  };
};

export const CustomArrow = ({ onClick, rightArrow }) => {
  return (
    <div
      css={[
        !rightArrow && tw`-rotate-90 left-2`,
        rightArrow && tw`rotate-90 right-2`,
        tw`absolute flex justify-center items-center z-10 cursor-pointer w-10 h-10 bg-primary rounded-full opacity-75`,
      ]}
      onClick={onClick}
    >
      <Icon Type={ArrowIcon} tw='float-left' />
    </div>
  );
};

const CustomDot = ({ index, onClick, active }) => {
  return (
    <div
      onClick={(e) => {
        onClick();
        e.preventDefault();
      }}
      css={[
        tw`border-2 border-icons cursor-pointer w-3 h-3 bg-transparent mb-3 rounded-full opacity-75 block mr-1 last:mr-0`,
        active && tw`bg-brand border-brand text-white`,
      ]}
    >
      {React.Children.toArray()[index]}
    </div>
  );
};

export const CarouselWrapper = ({ children = [], maxNumItems = 3, showDots }) => {
  const [isMoving, setIsMoving] = useState(false);
  const { windowSize } = useContext(AppContext);

  return (
    <div tw='min-w-[360px]'>
      <Carousel
        partialVisible
        swipeable
        ssr={true}
        showDots={showDots}
        customDot={<CustomDot />}
        responsive={responsive(maxNumItems)}
        deviceType={windowSize.adBreakPoint.toLowerCase()}
        pauseOnHover
        infinite
        isMoving={isMoving}
        beforeChange={() => setIsMoving(true)}
        afterChange={() => setIsMoving(false)}
        autoPlay
        autoPlaySpeed={3500 + Math.floor(Math.random() * 2000) + 1000}
        arrows
        // deviceType={deviceType}
        customLeftArrow={<CustomArrow />}
        customRightArrow={<CustomArrow rightArrow />}
      >
        {children}
      </Carousel>
    </div>
  );
};
